import { BankOutlined, ExperimentOutlined, KeyOutlined, StarOutlined } from '@ant-design/icons';
import { FC } from 'react';
import {
  AdminBGColor,
  AdminColor,
  GovBGColor,
  GovColor,
  ObsBGColor,
  ObsColor,
  RootBGColor,
  RootColor,
} from '../../Styles/role.color.constants';
import { RoleIcon } from '../common/RoleIcon/role.icon';

export interface UserRoleIconProps {
  role: string;
}

export const UserRoleIcon: FC<UserRoleIconProps> = (props: UserRoleIconProps) => {
  const { role } = props;
  return (
    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
      {role === 'Root' ? (
        <RoleIcon icon={<KeyOutlined />} bg={RootBGColor} color={RootColor} />
      ) : role === 'Admin' ? (
        <RoleIcon icon={<StarOutlined />} bg={AdminBGColor} color={AdminColor} />
      ) : role === 'GovernmentUser' ? (
        <RoleIcon icon={<BankOutlined />} bg={GovBGColor} color={GovColor} />
      ) : (
        <RoleIcon icon={<ExperimentOutlined />} bg={ObsBGColor} color={ObsColor} />
      )}
      <div>
        {role === 'Admin'
          ? 'Administrator'
          : role === 'Root'
          ? 'Super Admin'
          : role === 'GovernmentUser'
          ? 'Government User'
          : role === 'Observer'
          ? 'Observer'
          : role}
      </div>
    </div>
  );
};
